import { motion } from "framer-motion";
import { ArrowLeft, Sparkle } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

/**
 * ModuleStub — placeholder for Command Center modules that ship in
 * later phases. Keeps every route rendering something premium instead
 * of a 404 while the deep-builds are in progress.
 */
export default function ModuleStub({ title, blurb, icon: Icon, testid = "module-stub" }) {
  return (
    <div className="max-w-3xl mx-auto pt-6" data-testid={testid}>
      <Link
        to="/app"
        className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#F2DC8C]/70 hover:text-[#FFD700] transition-colors mb-6"
        data-testid={`${testid}-back`}>
        <ArrowLeft size={12}/> Back to Home
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="rounded-2xl p-8 sm:p-10 text-center relative overflow-hidden"
        style={{
          background:
            "radial-gradient(circle at 50% 0%, rgba(255,215,0,0.14) 0%, transparent 55%)," +
            "linear-gradient(180deg, rgba(26,18,6,0.85) 0%, rgba(5,3,0,0.95) 100%)",
          border: "1px solid rgba(255,215,0,0.45)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.55), inset 0 0 0 1px rgba(255,215,0,0.05)",
          backdropFilter: "blur(20px)",
        }}>
        <div className="mx-auto w-16 h-16 rounded-2xl flex items-center justify-center"
             style={{
               background: "linear-gradient(180deg, #FFF3AE 0%, #D4AF37 55%, #6b4d00 100%)",
               boxShadow: "0 12px 32px rgba(255,215,0,0.35)",
             }}>
          {Icon ? <Icon size={26} weight="fill" color="#0a0703"/> : <Sparkle size={26} weight="fill" color="#0a0703"/>}
        </div>

        <h1 className="mt-5 font-display text-[32px] sm:text-[40px] leading-tight"
            style={{
              background: "linear-gradient(180deg, #FFF3AE 0%, #FFD700 45%, #8a6a00 100%)",
              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
              letterSpacing: "0.02em",
            }}>
          {title}
        </h1>

        <div className="mt-2 text-[11px] uppercase tracking-[0.32em] text-[#F2DC8C]/60">
          Command Center · Coming soon
        </div>

        <p className="mt-5 text-[14px] leading-relaxed text-[#F2DC8C]/85 max-w-xl mx-auto">
          {blurb}
        </p>

        <div className="mt-8 flex items-center justify-center gap-2">
          <span className="w-1.5 h-1.5 rotate-45 bg-[#FFD700]" style={{ boxShadow: "0 0 8px #FFD700" }}/>
          <span className="text-[10px] uppercase tracking-[0.28em] text-[#F2DC8C]/50">
            Deep build in progress
          </span>
          <span className="w-1.5 h-1.5 rotate-45 bg-[#FFD700]" style={{ boxShadow: "0 0 8px #FFD700" }}/>
        </div>
      </motion.div>
    </div>
  );
}
